var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"slot":"no-body"},slot:"no-body"},[_c('div',{staticClass:"p-6",class:{
			'flex justify-between flex-row-reverse items-center': false,
			'text-center': !_vm.iconRight,
			'pb-0': !_vm.iconRight,
		}},[_c('div',[_c('h5',{staticClass:"mb-1 font-bold"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm._f("mayus")(_vm.visit_point_local.name))+"\n\t\t\t")]),_c('span',[_vm._v(_vm._s(_vm.visit_point_local.address))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }